import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Typography } from "@parkschannel/ui";
export const ParksHeading = ()=>{
    return /*#__PURE__*/ _jsxs("header", {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "h2",
                className: "text-neutral-900",
                children: "Discover Parks & Places"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "bodyLarge",
                className: "text-neutral-900 mb-6",
                children: "Find an amazing destination for your next trip."
            })
        ]
    });
};
